import {useStore} from "vuex";
import {computed} from "vue";
import router from "@/router";

export default function UseCrudHouse(houseId = undefined) {

  const store = useStore()
  store.commit('house/setHouseId', Number(houseId) || undefined)

  if (store.state.house.houseForm.id !== undefined) {

    const currentHouse = store.getters['housesList/getHouseById'](store.state.house.houseForm.id)

    if (currentHouse) {
      store.commit('house/setHouseData', currentHouse)
    } else {
      store.dispatch('house/getHouseById')
        .catch(() => store.commit('house/setHouseFormErrors', {pageNotFound: true}))
    }
  } else {
    store.commit('house/clearHousePassportData')
  }

  const year = computed({
    get: () => store.state.house.houseForm.year,
    set: (val) => store.commit('house/setFormYear', val)
  })

  const kadastr = computed({
    get: () => store.state.house.houseForm.kadastr,
    set: (val) => store.commit('house/setFormKadastr', val)
  })

  const canSubmitForm = computed(() =>
    store.state.house.houseForm.year &&
    store.state.house.houseForm.kadastr &&
    store.state.house.houseForm.house.zip_code &&
    store.state.house.houseForm.house.address &&
    store.state.house.houseForm.house.fias &&
    !store.state.house.isSubmitLoading
  )

  const submitForm = () => {
    store.commit('house/setSubmitLoading', true)
    store.dispatch(store.state.house.houseForm.id === undefined ? 'house/addHouse' : 'house/editHouse')
      .then(response => {
        store.commit('house/setSubmitLoading', false)
        if (response) {
          router.push('/')
        }
      })
      .catch(() => store.commit('house/setSubmitLoading', false))
  }

  const marker = computed(() => {
    const {lat, lon} = store.state.house.houseForm.house
    if (lat === undefined || lon === undefined) {
      return undefined
    }
    return [{coordinates: [lat, lon]}]
  })


  return {
    zip_code: computed(() => store.state.house.houseForm.house.zip_code),
    year,
    kadastr,
    canSubmitForm,
    submitForm,
    isCreationForm: computed(() => store.state.house.houseForm.id === undefined),
    marker,
    isHouseDataLoaded: computed(() => store.getters["house/hasHouseData"]),
    address: computed(() => store.state.house.houseForm.house.address),
    listLoadingStatus: computed(() => store.state.housesList.listLoadingStatus),
    pageNotFound: computed(() => store.state.house.houseFormErrors.pageNotFound),
    isSubmitLoading: computed(() => store.state.house.isSubmitLoading),
    isVariantsListLoading: computed(() => store.state.house.isVariantsListLoading)
  }
}
